import React, { useState } from "react";
import classes from "./LoginPage.module.css";
import { motion } from "framer-motion";
import { FaCheck } from "react-icons/fa6";
import LinedSection from "../component/LinedSection";
import { useNavigate } from "react-router-dom";
import { loginApi } from "../http/http";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setUser } from "../store/slices/userSlice";
import { useTranslation } from "react-i18next";

const plans = [
    {
        id: 1,
        name: "Passe Diário",
        price: "3MT",
        amount: "3.00",
        description: "24 Horas de Jogos",
    },
    {
        id: 2,
        name: "Passe Semanal",
        price: "20MT",
        amount: "20.00",
        description: "7 Dias de Acesso",
    },
    {
        id: 3,
        name: "Passe Mensal",
        price: "50MT",
        amount: "50.00",
        description: "30 Dias de Jogos",
    },
];

const LoginPage = () => {
    const [mobile, setMobile] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const dispatch=useDispatch();

    const {t}=useTranslation();

    const handleFormSubmission = async (e) => {
        try {
            e.preventDefault();
            setLoading(true);
            const response = await loginApi(mobile);

            if (response?.data?.result?.status == 1) {
                // true
                dispatch(setUser(response?.data?.result))
                toast.success("Logged in Successfully!");
                navigate("/home");
            }
            else if (response?.data?.result?.status == 0) {
                // low balance
                toast.info("User have a Low Balance!");
            }
            else {
                // not subscribed
                toast.error("User is not subscribed!");
            }

        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <main className={classes.main}>
            <div className={classes.glowLayer} />

            <LinedSection />

            <motion.section
                className={classes.container}
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >

                <div className={classes.bgGlowOne} />
                <div className={classes.bgGlowTwo} />

                <div className={classes.topLogoWrap}>
                    <img
                        src="/images/logo2.png"
                        alt="UV Gaming"
                        className={classes.logoImg}
                    />
                </div>

                <div className={classes.headingWrap}>
                    <h1 className={classes.title}>
                        {t("34")}
                        <span>{" "}{t("35")}</span>
                    </h1>
                    {/* <p className={classes.subtitle}>
            Passez au niveau supérieur avec une nouvelle expérience de jeu
          </p> */}
                </div>

                <form className={classes.card} onSubmit={handleFormSubmission}>
                    <div className={classes.tabSwitch}>
                        <button
                            type="button"
                            className={`${classes.tabBtn} ${classes.tabBtnActive}`}
                        >
                            {t("36")}
                        </button>

                        <button
                            type="button"
                            className={`${classes.tabBtn}`}
                            onClick={() => navigate("/subscribe")}

                        >
                            {t("37")}
                        </button>
                    </div>

                    <div className={classes.formBlock}>
                        <label className={classes.label}>{t("38")}</label>

                        <div className={classes.phoneField}>
                            <div className={classes.phoneCode}>+255</div>
                            <input
                                type="tel"
                                placeholder={t("39")}
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                className={classes.phoneInput}
                            />
                        </div>
                    </div>

            
                    <button type="submit" className={classes.confirmBtn}
                    >
                       {t("46")}
                    </button>
                    {/* 
                    <div className={classes.bottomNote}>
                        Pagamento via Saldo Principal ou M-Pesa
                    </div> */}
                </form>

                <div className={classes.footerText}>
                    © UVCANN SOLUTIONS LLP
                </div>
            </motion.section>
        </main>
    );
};

export default LoginPage;